import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'
import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled, { css } from 'styled-components'
import { _searchTileContainerQueryUp } from './_MetaSearchTileBase'

const Container = styled.div<{ $density: SearchTileDensity }>`
  grid-area: content-secondary;
  display: flex;
  flex-direction: ${props => props.$density === 'compact' ? 'column' : 'row'};
  gap: ${props => props.$density === 'compact' ? rem(12) : rem(16)};
  justify-content: flex-start;
  width: 100%;

  & > * {
    flex: ${props => props.$density === 'compact' ? '0 1 auto' : '1'};
  }

  ${_searchTileContainerQueryUp.tablet} {
    ${props => props.$density === 'compact' ?
      css`
        justify-content: flex-start;
      ` :
      css`
        justify-content: flex-end;
      `}
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    justify-content: flex-start;
  }

  ${_searchTileContainerQueryUp.desktopLarge} {
    ${props => props.$density === 'compact' ?
      css`
        justify-content: flex-start;
      ` :
      css`
        justify-content: flex-end;
      `}
  }
`

interface Props extends PropsWithChildren {
  callToAction?: ReactElement
  /**
   * @default default
   */
  density?: SearchTileDensity
}

function _MetaSearchTileContentSecondary({
  children,
  density = 'default',
}: Props) {
  return <Container className={_MetaSearchTileContentSecondary.name} $density={density}>
    {children}
  </Container>
}

export default _MetaSearchTileContentSecondary
